export enum Invites {
  VERIFY_INVITE_REQUEST = '@invites/VERIFY_INVITE_REQUEST',
  VERIFY_INVITE_SUCCESS = '@invites/VERIFY_INVITE_SUCCESS',
  VERIFY_INVITE_FAIL = '@invites/VERIFY_INVITE_FAIL',

  GET_INVITE_REQUEST = '@invites/GET_INVITE_REQUEST',
  GET_INVITE_SUCCESS = '@invites/GET_INVITE_SUCCESS',
  GET_INVITE_FAIL = '@invites/GET_INVITE_FAIL',

  ACCEPT_INVITE_REQUEST = '@invites/ACCEPT_INVITE_REQUEST',
  ACCEPT_INVITE_SUCCESS = '@invites/ACCEPT_INVITE_SUCCESS',
  ACCEPT_INVITE_FAIL = '@invites/ACCEPT_INVITE_FAIL',

  CLEAR_INVITE = '@invites/CLEAR_INVITE',
}
